export const PING = "@websocket/PING";
//dispatched by WebSocketManager forwardAction
export const PONG = "@websocket/PONG";
